import { createAction } from 'redux-actions';

export const setGlobal = createAction('app/SET_GLOBAL');

export const setIsSocketConnected = createAction('app/SET_SOCKET_CONNECTED');

export const setBrowserId = createAction('app/SET_BROWSER_ID');

export const setEchoAgent = createAction('app/SET_ECHO_AGENT');

export const setEchoChannel = createAction('app/SET_ECHO_CHANNEL');

export const setIsSubApp = createAction('app/SET_IS_SUB_APP');
